/**
 * Different types of Highlight .
 *
 * @public
 */
enum Highlight {
	/**
	 * @public
	 */
	None = "None",

	/**
	 * @public
	 */
	Positive = "Positive",

	/**
	 * @public
	 */
	Critical = "Critical",

	/**
	 * @public
	 */
	Negative = "Negative",

	/**
	 * @public
	 */
	Information = "Information",
}

export default Highlight;
